import {BD_STATES, BdState, BdStateStore} from '@bindoc-projects/geographic-domain-lib';
import {Subject} from 'rxjs';
import {BdMapsStateSelectOptions} from './select-options';

export abstract class BdMapsStateSelectHandler<T> {

  protected _options: BdMapsStateSelectOptions;

  /**
   * the base set of resources
   */
  protected _states: BdState[];

  /**
   * the set of resources with applied filter
   */
  public statesOptions: BdState[] = [];

  /**
   * set of selected resources
   */
  public selectedResources: T;

  /**
   * emits selected resources on change
   */
  public statesSelect$ = new Subject<T>();

  public filter(searchTerm: string): void {
    let filteredValues: BdState[];

    if (searchTerm) {
      searchTerm = searchTerm.toLowerCase();

      filteredValues = this._states
        .filter(value => value.name.toLowerCase().indexOf(searchTerm) > -1)
        .sort((a, b) => {
          if (!a || !b) {
            return !a ? 1 : -1;
          }

          return a.name.localeCompare(b.name);
        });
    } else {
      filteredValues = this._states
        .slice()
        .sort((a, b) => {
          if (!a || !b) {
            return !a ? 1 : -1;
          }

          return a.name.localeCompare(b.name);
        });
    }

    this.statesOptions = filteredValues;
  }

  protected _getStateOptions(
    defaultStates: BdState[] = BD_STATES,
    includeBund = true
  ): BdState[] {

    let result: BdState[];

    if (includeBund) {

      // if [defaultStates] contains 'Bund'-State, all fine, else add this special state
      if (defaultStates.length === BD_STATES.length) {
        result = defaultStates;
      } else {
        result = defaultStates.concat(BdStateStore.byId(-1));
      }

    } else {
      result = defaultStates.filter(state => state.id !== -1);
    }

    return result;
  }

  abstract get states(): BdState[];

  abstract set states(value: BdState[]);

  abstract set options(options: BdMapsStateSelectOptions);

  public abstract updateSelection(selection: T): void;
}
